import { useStaffStore } from '../stores/staff.store';
import { Staff } from '../types';

/**
 * Helper function to extract staffs from the new staffsByDepartment structure
 */
export const getStaffsFromDepartment = (
  staffsByDepartment: Record<string, Staff[] | Record<string, Staff[]>>,
  departmentId: string
): Staff[] => {
  const departmentData = staffsByDepartment[departmentId];
  if (!departmentData) return [];

  // If it's an array (old format), return it directly
  if (Array.isArray(departmentData)) {
    return departmentData;
  }

  // If it's an object (new format), return all staffs from all roles
  const allStaffs: Staff[] = [];
  for (const staffs of Object.values(departmentData)) {
    if (Array.isArray(staffs)) {
      allStaffs.push(...staffs);
    }
  }
  return allStaffs;
};

/**
 * Common utility function to find staff ID by code from staffsByDepartment
 * Handles both old format (Staff[]) and new format (Record<string, Staff[]>)
 */
export const findStaffIdByCode = (code: number): string => {
  // Get fresh data directly from store instead of from hook
  const currentStaffsByDepartment = useStaffStore.getState().staffsByDepartment;

  // Search through all staffs in staffsByDepartment
  for (const [, departmentStaffs] of Object.entries(currentStaffsByDepartment)) {
    const staffs = Array.isArray(departmentStaffs)
      ? departmentStaffs
      : Object.values(departmentStaffs).flat();
    const staff = staffs.find((s) => s.code === code);
    if (staff) {
      return staff.id;
    }
  }
  return '';
};
